import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// 常量定义在函数外部，避免重复创建
const FEATURE_KEYS = Object.freeze({
  TENANT_ID: 'tenant_id',
  MARKETING_CLOUD_TENANT_ID: 'marketing_cloud_tenant_id',
});

/**
 * 账户功能特性 Composable
 * 用于获取和判断当前账户的 custom_attributes
 */
export function useAccountFeatures() {
  const getCurrentAccount = useMapGetter('accounts/getAccount');
  const currentAccountId = useMapGetter('getCurrentAccountId');

  // 响应式获取当前账户
  const account = computed(() => {
    if (!currentAccountId.value) return null;
    return getCurrentAccount.value(currentAccountId.value);
  });

  // 账户是否已加载
  const isAccountLoaded = computed(() => !!account.value);

  // 获取 custom_attributes 对象
  const customAttributes = computed(
    () => account.value?.custom_attributes ?? {}
  );

  /**
   * 检查是否拥有某个 custom attribute
   */
  const hasCustomAttribute = key => {
    if (!key) return false;
    return !!customAttributes.value[key];
  };

  /**
   * 获取 custom attribute 的值
   */
  const getCustomAttribute = key => {
    if (!key) return undefined;
    return customAttributes.value[key];
  };

  // 预定义的特性
  const hasTenantId = computed(() =>
    hasCustomAttribute(FEATURE_KEYS.TENANT_ID)
  );
  const tenantId = computed(() => getCustomAttribute(FEATURE_KEYS.TENANT_ID));

  const hasMarketingCloudTenantId = computed(() =>
    hasCustomAttribute(FEATURE_KEYS.MARKETING_CLOUD_TENANT_ID)
  );
  const marketingCloudTenantId = computed(() =>
    getCustomAttribute(FEATURE_KEYS.MARKETING_CLOUD_TENANT_ID)
  );

  return {
    account,
    isAccountLoaded,
    customAttributes,
    hasCustomAttribute,
    getCustomAttribute,
    FEATURE_KEYS,
    hasTenantId,
    tenantId,
    hasMarketingCloudTenantId,
    marketingCloudTenantId,
  };
}
